import {Dominio as DominioBase, type TSite} from "services-comun-meteored/modules/portal/tiempo";
import {immute} from "services-comun/modules/utiles/object";

export class Dominio extends DominioBase {
    /* STATIC */
    public static ALL_ID: TSite[] = immute(["ar", "at", "bo", "br", "ca", "cl", "cr", "de", "do", "ec", "en", "es", "eu", "fr", "hn", "it", "mx", "nl", "pa", "pe", "pt", "py", "ru", "uy", "ve"]);

    public static getIndex(idx: number): Dominio {
        const sites = Object.keys(this.IDS) as TSite[];
        return this.getID(sites[idx]??"eu");
    }
}
